// Barrel centralizado para autenticação e páginas públicas
import * as auth from "./auth";
import * as pages from "./pages";
import * as shortLinks from "./short-links";
import * as qrCodes from "./qr-codes";
import * as subscriptions from "./subscriptions";

export const api = {
  ...auth,
  ...pages,
  ...shortLinks,
  ...qrCodes,
  ...subscriptions,
};

export type { ApiResponse } from "./http";
